import { useEffect, useState } from 'react';
import { getMessaging, getToken } from 'firebase/messaging';
import firebaseApp from '@utils/firebase';

const useFcmToken = () => {
  const [token, setToken] = useState('');

  useEffect(() => {
    const retrieveToken = async () => {
      try {
        if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
          const messaging = getMessaging(firebaseApp);
          const permission = await Notification.requestPermission();
          if (permission === 'granted') {
            const currentToken = await getToken(messaging, {
              vapidKey:
                'BLpY21abe_otWKZdcwwF0Lcs_4vQrkF0NPFc3uC0qmn_cFYC5CbbxCC2nC9X6irjwOxqCjPXZYu4oLIMeswnp5c',
            });
            if (currentToken) {
              setToken(currentToken);
            }
          }
        }
      } catch (error) {
      }
    };

    retrieveToken();
  }, []);

  return { fcmToken: token };
};

export default useFcmToken;
